import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import EditInterestModal from '../../Modals/Interest/EditInterestModal';
import style from './styles/style.module.css';

class InfiniteCategoriesTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            categoryInEdit: null,
            categoryInEditIndex: -1,
        };
    }
    updateInterest = ( index, interestid, data ) => {
        this.props.updateInterest( interestid, data )
        .then( ( category ) => {
            return this.props.onInterestUpdated && this.props.onInterestUpdated( index, category );
        } );
    }
    openEditModal = ( index, category ) => {
        this.setState( { categoryInEdit: category, categoryInEditIndex: index } );
    }
    onEditSubmit = ( category ) => {
        var index = this.state.categoryInEditIndex;
        this.props.onInterestUpdated( index, category );
        this.setState( { categoryInEdit: null, categoryInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { categoryInEdit: null, categoryInEditIndex: -1 } );
    }



    render() {
        const { interests } = this.props;
        const { categoryInEdit } = this.state;

        return (
            <div>
                <InfiniteTable
                className={ style.categoriesTable }
                elementHeight={ 90 }>
                    { this.arrayTableRows( interests ) }
                </InfiniteTable>
                { categoryInEdit !== null &&
                    <EditInterestModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    category={ categoryInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( categories ) => {
        var rows = categories.map( ( category, index ) => {
            return (
                <InfiniteTable.Row key={ category.interestid } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.categorytext }>
                        { category.interest }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Icon source='fontAwesome' icon='fas/faCircle' style={ { color: category.deactivated ? 'red' : 'blue' } } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, category );
                            } }/>
                            <DLMenu.Item text={ category.deactivated ? 'Activate' : 'Deactivate' }
                            onClick={ () => {
                                this.updateInterest( index, category.interestid,
                                    {
                                        deactivated: !category.deactivated,
                                        interest: category.interest,
                                    } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    CATEGORY NAME { sortIcon( 'interest,interestid' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>
                    ACTIVE { sortIcon( 'deactivated,interest,interestid' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
InfiniteCategoriesTable.defaultProps = {
    onInterestUpdated: ()=>{},
    categories: [],
};

const mapDispatchToProps = () => {
    return {
        updateInterest: ( interestid, data ) => {
            return dAPI.patch( `/interests/${ interestid }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( InfiniteCategoriesTable );
